import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import UserAvatar from "@entrilia/shared/components/UserAvatar.tsx";
import CompaniesIcon from "@entrilia/shared/icons/CompaniesIcon.tsx";
import type { SharedWithEntity } from "../../../../../../api/types/svTypes.ts";

interface Props {
  sharedWith: SharedWithEntity[];
  tooltip: string;
  onClick?: () => void;
}

export default function SharedWithIcons({ sharedWith, tooltip, onClick }: Props) {
  return (
    <Tooltip
      title={tooltip}
      enterDelay={500}
      enterNextDelay={500}
      slotProps={{ tooltip: { sx: { whiteSpace: "pre-line" } } }}
      arrow
      disableInteractive
    >
      <AvatarGroup
        max={2}
        onClick={onClick}
        slotProps={{ surplus: { sx: { color: "secondary.main" } } }}
        sx={{
          cursor: onClick ? "pointer" : "default",
          ".MuiAvatar-root": { height: 24, width: 24, fontSize: 12 },
        }}
      >
        {sharedWith.map((entity, index) => {
          if (entity.type === "Company") {
            return (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <Avatar key={`company-${index}-${entity.name}`} sx={{ width: 24, height: 24 }}>
                <CompaniesIcon sx={{ width: 16, height: 16 }} />
              </Avatar>
            );
          }
          if (entity.type === "Group") {
            return (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <Avatar key={`group-${index}-${entity.name}`} sx={{ width: 24, height: 24 }}>
                <PeopleOutlinedIcon sx={{ width: 16, height: 16 }} />
              </Avatar>
            );
          }
          // eslint-disable-next-line @eslint-react/no-array-index-key
          return <UserAvatar key={`user-${index}-${entity.name}`} userName={entity.name} size="small" />;
        })}
      </AvatarGroup>
    </Tooltip>
  );
}
